import React, { useState, useEffect } from 'react';
import CardSeplag from "../../../components/CardSeplag";
import CardExibirPdf from "../../../components/CardExibirPDF";
import { Dropdown  } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import {carregarArvoreMonitora, 
  carregarArvoreMonitoraComFiltro, 
  buscarExercicio, buscaCiclo, buscarOrgaos,
  buscarAcao, buscaProduto, buscarSubAcao,
  gerarRelatorioStatusExecucao, buscaSubUnidadeExecucao, 
  buscaStatusExecucao,
  buscaUnidadeExecucao} from "../../../service/ArvoreMonitora";

import "./style.css";
import download from 'downloadjs';

const RelStatusExecucao = () => {

    const OpcoesPrioritario  = [
        {
            name: "TODOS",
            code: " ",
          },
          {
            name: "Não",
            code: "N",
          },
          {
            name: "Sim",
            code: "S",
          },
        ]; 
    
    const TipoRelatorio = [
         {  name: "PDF",
            code: "P",    
        },
        
        {   name: "EXCEL",
            code: "E",
        },
        ];

    const OpcoesIntervaloExec = [
      { name: "0% à 40%",
        code: "0-40",
      },
      { name: "41% à 60%",
        code: "41-60",
      },
      { name: "61% à 80%",
        code: "61-80",
      },
      { name: "81% à 90%",
        code: "81-90",
      },
      { name: "91% à 110%",
        code: "91-110",
      },
      { name: "111% à 120%",
        code: "111-120",
      },
      { name: "121% à 140%",
        code: "121-140",
      },
      { name: "141 à 160%",
        code: "141-160",
      },
      { name: "161% Acima",
        code: "161-x",
      },
  ]

  const OpcoesSolucaoRestricoes = [
    { name: "Todas",
      code: "T",
    },
    { name:"Solucionadas",
      code: "S",
    },
    { name: "Não Solicionadas",
      code: "N",
    }
  ]

const [visible, setVisible] = useState(false);
const [ptaMonitoraSelecionado, setPtaMonitoraSelecionado] = useState(); 
              
const [cDadosArvore, setCDadosArvore] = useState([])
const [cDadosExercicios, setCDadosExercicios] = useState([]);
const [cDadosCiclo, setCDadosCiclo] = useState([]); 
const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
const [cDadosUOs, setCDadosUOs] = useState([]);
const [cDadosProgramas, setCDadosProgramas] = useState([]); 
const [cDadosAcoes, setCDadosAcoes] = useState([]);
const [cDadosProdutoAcoes, setCDadosProdutoAcoes] = useState([]);
const [cDadosSubAcoes, setCDadosSubAcoes] = useState([]);
const [cDadosUnidadeExecucao, setCDadosUnidadeExecucao] = useState([]);
const [cDadosSubUnidadeExecucao, setCDadosSubUnidadeExecucao] = useState([]);
const [cDadosStatusExecucao, setCDadosStatusExecucao] = useState([]);
const [cDadosItemPrioritario, setCDadosItemPrioritario] = useState([]);
const [cDadosTipoRelatorio, setCDadosTipoRelatorio] = useState([]);
              
const [exercicioSelecionado, setExercicioSelecionado] = useState([]); 
const [cicloSelecionado, setCicloSelecionado] = useState([]);
const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
const [uoSelecionada, setUoSelecionada] = useState([]);
const [programaSelecionado, setProgramaSelecionado] = useState([]);
const [acaoSelecionada, setAcaoSelecionada] = useState([]);
const [produtoAcaoSelecionada, setProdutoAcaoSelecionada] = useState([]);
const [unidadesExecucaoSelecionada, setUnidadesExecucaoSelecionada] = useState([]);
const [subUnidadesExecucaoSelecionada, setSubUnidadesExecucaoSelecionada] = useState([]);
const [statusExecucaoSelecionado, setStatusExecucaoSelecionado] = useState([]);  
const [intervaloExecSelecionado, setIntervaloExecSelecionado] = useState([]);  
const [solucaoRestricoesSelecinado, setSolucaoRestricoesSelecinado] = useState([]);  
const [subAcaoSelecionada, setSubAcaoSelecionada] = useState([]);
const [itemPrioritarioSelecionado, setItemPrioritarioSelecionado] = useState([]);
const [tipoRelatorioSelecionado, setTipoRelatorioSelecionado] = useState([]);
              
const [tituloPDF, setTituloPDF] = useState('');
const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
const [isExibirPDF, setIsExibirPDF] = useState(false);
              
                 
const [exibirRelatorio, setExibirRelatorio] = useState(false);

  useEffect(() => {
    setCDadosExercicios([]);
    buscarExercicio().then((res) => {        
      setCDadosExercicios(res.data.listaExercicios)
      
    })
    buscaStatusExecucao().then((res) => {
      setCDadosStatusExecucao(res.data) 
  })   
}, []);  
        
   function montarArvore(dadosArvore) {
      if(dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
           setCDadosArvore(dadosArvore.arvorePtaMonitoras)
      } else {
           setCDadosArvore({content : { key : null, statusItem : null, tipoItemPta : null}})
      }
          setCDadosExercicios(dadosArvore!= null ? dadosArvore.listaExercicios : null)
          setCDadosCiclo(dadosArvore && dadosArvore.parametroExercicio ? dadosArvore.parametroExercicio : {cicloMonitoramento : {statusCiclo : ''}})
          setCDadosOrgaos(dadosArvore!= null ? dadosArvore.orgaoFiplans : null)
          setCDadosUOs(dadosArvore!= null ? dadosArvore.unidadeOrcamentarias : null)
          setCDadosProgramas(dadosArvore!= null ? dadosArvore.programas : null)
          setCDadosItemPrioritario(dadosArvore!= null ? dadosArvore.opcoesPrioritario: null)
          setCDadosTipoRelatorio(dadosArvore!= null ? dadosArvore.tipoRelatorio: null)
          setCDadosUnidadeExecucao(dadosArvore!= null ? dadosArvore.idenUnidadeExecucao: null)
          setCDadosStatusExecucao(dadosArvore!= null ? dadosArvore.statusExecucao: null)
          
        }
    
        let defaultArvoreMonitora = {
    
          arvorePtaMonitoras : cDadosArvore,
          listaExercicios : cDadosExercicios,
          parametroExercicio : cDadosCiclo,
          orgaoFiplans : cDadosOrgaos,
          unidadeOrcamentarias : cDadosUOs,
          programas : cDadosProgramas,
          acao : cDadosAcoes,
          produto : cDadosProdutoAcoes,
          subAcao : cDadosSubAcoes,
          ciclo : cDadosCiclo,
          listaUnidadeExecucao: cDadosUnidadeExecucao,
          statusExecucao: cDadosStatusExecucao,
         
                
        }        

    const [filtro, setFiltro] = useState(false);
    
    const onChangeExercicio = (e) => {
        setExercicioSelecionado(e.value)
        setOrgaoSelecionado(null)
        setCDadosUOs([])
        setUoSelecionada(null)
        setCDadosProgramas([])
        setProgramaSelecionado(null)
        setCDadosAcoes([])
        setAcaoSelecionada(null)
        setCDadosProdutoAcoes([])
        setProdutoAcaoSelecionada(null)
        setCDadosSubAcoes([])
        setSubAcaoSelecionada(null)
        setCDadosStatusExecucao([])
        setStatusExecucaoSelecionado(null)
  
        buscaCiclo(e.value.idenExercicio).then(retorno =>{
          setCDadosCiclo(retorno.data)
           buscarOrgaos(e.value.idenExercicio).then(res => {
            setCDadosOrgaos(res.data)
            buscaStatusExecucao(e.value.idenStatus).then(res => {
              setCDadosStatusExecucao(res.data)
              
            })
            
         })
    })
}

const onChangeOrgao = (e) => {
        setOrgaoSelecionado(e.value)
        setUoSelecionada(null)
        setProgramaSelecionado(null)
        setCDadosUOs(null)
        setCDadosProgramas(null)
        setCDadosArvore(null)
        let filtro = {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: e.value.idenOrgao,
          idenUo : null,
          idenPrograma : null
        }
        carregarArvoreMonitoraComFiltro(filtro,defaultArvoreMonitora).then((res) => {
          setCDadosCiclo(res.parametroExercicio)
          setCDadosOrgaos(res.orgaoFiplans)
          setCDadosUOs(res.unidadeOrcamentarias)
        })
}

const onChangeUo = (e) => {
  setUoSelecionada(e.value)
  setProgramaSelecionado(null)
  setCDadosProgramas(null)
  setCDadosArvore(null)
  let filtro = {
    idenExercicio: exercicioSelecionado.idenExercicio,
    idenOrgao: orgaoSelecionado.idenOrgao,
    idenUo : e.value.idenUo,
    idenPrograma : null
  }
  carregarArvoreMonitoraComFiltro(filtro,defaultArvoreMonitora).then((res) => {
    setCDadosCiclo(res.parametroExercicio)
    setCDadosOrgaos(res.orgaoFiplans)
    setCDadosUOs(res.unidadeOrcamentarias)
    setCDadosProgramas(res.programas)
   })
}
  
const onChangePrograma = (e) => {
  setProgramaSelecionado(e.value)
  let listaPrograma  = [e.value.idenPrograma]
  let listaUnidOrcamentaria = [uoSelecionada.idenUo]
  let JsonBody ={
    listaPrograma,
    listaUnidOrcamentaria
  }
  buscarAcao(JsonBody).then((res)=> {
    setCDadosAcoes(res.data);
    setAcaoSelecionada(null);
    setCDadosProdutoAcoes([]);
    setProdutoAcaoSelecionada(null);
    setSubAcaoSelecionada(null);
  })    
}

const onChangeAcao = (e) => {
  setAcaoSelecionada(e.value)
  let idenPtaMonitora = e.value.key
  buscaProduto(idenPtaMonitora).then(retorno =>{
    setCDadosProdutoAcoes(retorno.data);
    setProdutoAcaoSelecionada(null);
    setCDadosSubAcoes([]);
    setSubAcaoSelecionada(null);
  })   
} 

const onChangeProdutoAcao = (e) => {
  setProdutoAcaoSelecionada(e.value)
  let idenPtaMonitora = e.value.key
  buscaUnidadeExecucao(idenPtaMonitora).then(retorno => {
    setCDadosUnidadeExecucao(retorno.data);
    setUnidadesExecucaoSelecionada(null);
  })

}

// const onChangeSubAcao = (e) => {
  //   setSubAcaoSelecionada(e.value)  
  // }

  const onChangeUnidadeExecucao = (e) => {
    setUnidadesExecucaoSelecionada(e.value)
    let listaUnidadeExecucao  = [e.value.idenUnidadeExecucao]
    let listaProdutoAcaoSelecionada = [produtoAcaoSelecionada.idenPtaFiplan]
    let JsonBody ={
      listaProdutoAcaoSelecionada,
      listaUnidadeExecucao      
    }
    buscaSubUnidadeExecucao(JsonBody).then((res)=> {
      setCDadosSubUnidadeExecucao(res.data);
      setSubAcaoSelecionada(null);
      setCDadosUnidadeExecucao([]);
      setUnidadesExecucaoSelecionada(null);        
    })    
  }

  const onChangeSubUnidadesExecucaoSelecionada = (e) => {
     setSubUnidadesExecucaoSelecionada(e.value)
     let listaSubUnidadeExecucao = [e.value.idenUnidadeExecucao]
     let JsonBody ={
      listaSubUnidadeExecucao,
  }
  buscaStatusExecucao(JsonBody).then((res) => {
    setCDadosStatusExecucao(res.data);
    setStatusExecucaoSelecionado(null);
    setCDadosUnidadeExecucao([]);
    setUnidadesExecucaoSelecionada(null);
  })      
} 
   
  const onChangeStatusDeExecucao = (e) => {
    setStatusExecucaoSelecionado(e.value)   
  } 

  const onChangeIntervalodeExec = (e) => {
    setIntervaloExecSelecionado(e.value)    
  } 

  const onChangeSolucaoRestricoes = (e) => {
    setSolucaoRestricoesSelecinado(e.value)    
  } 

 const onChangeItemPrioritario = (e) => {
    setItemPrioritarioSelecionado(e.value)    
 } 

 const onChangeTipoRelatorio = (e) => {
  setTipoRelatorioSelecionado(e.value)    
} 

const gerarRelatorio = () =>{
  let idenExercicio   = exercicioSelecionado && exercicioSelecionado!= null ? exercicioSelecionado.idenExercicio : null
  let idenCiclo       = cicloSelecionado && cicloSelecionado!= null ? cicloSelecionado.idenCiclo : null
  let idenOrgao       = orgaoSelecionado && orgaoSelecionado != null? orgaoSelecionado.idenOrgao : null
  let listaUo         = uoSelecionada && uoSelecionada != null ? [uoSelecionada.idenUo] : []
  let listaPrograma   = programaSelecionado && programaSelecionado != null ? [programaSelecionado.idenPrograma] : []
  let listaAcao       = acaoSelecionada && acaoSelecionada != null ?  [acaoSelecionada.idenPtaFiplan] : []
  let listaProduto    = produtoAcaoSelecionada && produtoAcaoSelecionada != null ? [produtoAcaoSelecionada.idenPtaFiplan] : []
  let listaUnidadeExecucao      = unidadesExecucaoSelecionada && unidadesExecucaoSelecionada != null ? [unidadesExecucaoSelecionada.idenUnidadeExecucao] : []
  let listaSubUnidadeExecucao   = subUnidadesExecucaoSelecionada && subUnidadesExecucaoSelecionada != null ? [subUnidadesExecucaoSelecionada.idenUnidadeExecucao] : []
  let listaStatusExecucao       = statusExecucaoSelecionado && statusExecucaoSelecionado != null ? [statusExecucaoSelecionado.idenStatus] : []
  let intervaloExec             = intervaloExecSelecionado && intervaloExecSelecionado != null ? [intervaloExecSelecionado.code] : null
  let solucaoRestricoes         = solucaoRestricoesSelecinado && solucaoRestricoesSelecinado != null ? [solucaoRestricoesSelecinado.code] : null
  // let listaSubAcao    = subAcaoSelecionada && subAcaoSelecionada != null ? [subAcaoSelecionada.idenPtaFiplan] : []
  let flagPrioritario = itemPrioritarioSelecionado && itemPrioritarioSelecionado != null ? itemPrioritarioSelecionado.code : null
  let tipoRelatorio   = tipoRelatorioSelecionado && tipoRelatorioSelecionado != null ? tipoRelatorioSelecionado.code : null
  let JsonBody = {
    idenExercicio,
    idenCiclo,
    idenOrgao,
    listaUo,
    listaPrograma,
    listaAcao,
    listaProduto,
    listaUnidadeExecucao,
    listaSubUnidadeExecucao,
    listaStatusExecucao,
    intervaloExec,
    solucaoRestricoes,
    // listaSubAcao,
    flagPrioritario,
    tipoRelatorio
   }

   gerarRelatorioStatusExecucao(JsonBody).then(res=>{
    if(tipoRelatorio == 'E'){
      download(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");          
  }else{
      //download(`data:application/pdf;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}.pdf`, "application/pdf");          
      let valorMb = res.data.dadosRelatorioBase64.length /1024000;
      if(valorMb >2){
        //this.$toast.add({severity:'warn', summary: 'Tamanho excessivo', detail:"Devido ao tamanho do arquivo, realizou-se o download do relatório.", life: 5000}); 
        download(`data:application/pdf;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/pdf");     
      }else{
        setTituloPDF(res.data.nomeArquivo)
        setDadosRelatorioBase64(res.data.dadosRelatorioBase64)
        setIsExibirPDF(true)
      }
    }
  })
}

function fecharJanela() {
  setExibirRelatorio(false);
  setIsExibirPDF(false)
  }
  
  function abreJanela() {           
  setExibirRelatorio(true);
 }
  return(

    <CardSeplag title="MONITORAMENTO: RELATÓRIO DE STATUS DE EXECUÇÃO">
      <div className="p-fluid grid line-height-6">
         <div className="field col-12 md:col-12 ">
           <div className="p-fluid grid line-height-6">
           <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selExercicio' value={exercicioSelecionado} options={cDadosExercicios} onChange={onChangeExercicio} optionLabel="ano" filter showClear filterBy="ano" placeholder='Selecione um exercício'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selCiclo">Ciclo</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selCiclo' value={cicloSelecionado} options={cDadosCiclo} onChange={e => {setCicloSelecionado(e.value)}} optionLabel="descCiclo" filter showClear filterBy="descricaoFiplan" placeholder='Selecione um Ciclo'/>
              </span>
            </div>    
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selOrgao' value={orgaoSelecionado} options={cDadosOrgaos} onChange={onChangeOrgao} optionLabel="descricaoFiplan" filter showClear filterBy="descricaoFiplan" placeholder='Selecione um Órgão'/>
              </span>
            </div> 
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selUO">U.O.</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selUO' value={uoSelecionada} options={cDadosUOs} onChange={onChangeUo} optionLabel="descricaoFiplan" filter showClear filterBy="descricaoFiplan" placeholder='Selecione uma U.O.'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selPrograma">Programa</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selPrograma' value={programaSelecionado} options={cDadosProgramas} onChange={onChangePrograma} optionLabel="descricaoFiplan" filter showClear filterBy="descricaoFiplan" placeholder='Selecione um Programa'/>
              </span>
            </div>    
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selAcao">Ação</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selAcao' value={acaoSelecionada} options={cDadosAcoes} onChange={onChangeAcao} optionLabel="descFiplan" filter showClear filterBy="descFiplan" placeholder='Selecione uma Ação'/>
              </span>
            </div> 
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selProdAcao">Produto da Ação</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selProdAcao' value={produtoAcaoSelecionada} options={cDadosProdutoAcoes} onChange={onChangeProdutoAcao} optionLabel="descFiplan" filter showClear filterBy="ano" placeholder='Selecione um Produto da Ação'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selUnidadesExecucao">Unidade de Execução</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selUnidadesExecucao' value={unidadesExecucaoSelecionada} options={cDadosUnidadeExecucao} onChange={onChangeUnidadeExecucao} optionLabel="descricaoFiplan" filter showClear filterBy="descricaoFiplan" placeholder='Selecione uma Unidade de Execução'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selSubUnidadesExecucao">Sub-Unidade de Execução</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selSubUnidadesExecucao' value={subUnidadesExecucaoSelecionada} options={cDadosUnidadeExecucao} onChange={onChangeSubUnidadesExecucaoSelecionada} optionLabel="descricaoFiplan" filter showClear filterBy="descricaoFiplan" placeholder='Selecione uma Sub-Unidade de Execução'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selStatusExecucao">Status de Execução</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selStatusExecucao' value={statusExecucaoSelecionado} options={cDadosStatusExecucao} onChange={onChangeStatusDeExecucao} optionLabel="descStatus" filter showClear filterBy="descStatus" placeholder='Selecione um Status'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selIntervalo">Intervalo de Percentual de Execução</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selIntervalo' value={intervaloExecSelecionado} options={OpcoesIntervaloExec} onChange={onChangeIntervalodeExec} optionLabel="name" filter showClear filterBy="true" placeholder='Selecione o Intervalo de Percentual de Execução'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selSolucao">Solução de Restrições</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selSolucao' value={solucaoRestricoesSelecinado} options={OpcoesSolucaoRestricoes} onChange={onChangeSolucaoRestricoes} optionLabel="name" filter showClear filterBy="true" placeholder='Selecione uma Solução de Restrições'/>
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selPrio">Item Prioritário</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selItemPrioritario' value={itemPrioritarioSelecionado} options={OpcoesPrioritario} onChange={onChangeItemPrioritario} optionLabel="name" filter showClear filterBy="true" placeholder='Selecione um Item Prioritário'/>
              </span>
            </div> 
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
                <Dropdown emptyMessage="Dados não encontrados" emptyFilterMessage="Opção não encontrada" id='selTipo' value={tipoRelatorioSelecionado} options={TipoRelatorio} onChange={onChangeTipoRelatorio } optionLabel="name" filter showClear filterBy="true" placeholder='Selecione um Tipo de Impressão de Relatório'/>
              </span>
         </div> 
       </div>         
     </div>   
    </div>          
     <div className="col-12 md:col-1">
     <Button type="button"  label="Gerar" icon="pi pi-file" className="col-3 col-12" onClick={gerarRelatorio}/> 
          { isExibirPDF && 
          
          <CardExibirPdf 
      tamanhoTela="'85.vw'" alturaTela="'350.vh'" stringPDF={'data:application/pdf;base64,'+dadosRelatorioBase64} tituloTela={tituloPDF} isExibirPDF={isExibirPDF} position = "center" onHide={fecharJanela}
     />            
    }    
    </div>    
  </CardSeplag>
 )    
} 
 export default RelStatusExecucao;